import { ReduxStore } from 'store/types';

export const selectAppSessionId = (store: ReduxStore) =>
    store.sessions.appSessionId;

export const selectVideoSessionId = (store: ReduxStore) =>
    store.sessions.videoSessionId;
